import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getPublisherSingleAppAction = createAsyncThunk(
    'get-publisher-single-app-data',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/single-publisher-app-data/${data}`) 
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getPublisherSingleAppSlice = createSlice({
    name: 'get-publisher-single-app-data',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getPublisherSingleAppAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getPublisherSingleAppAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getPublisherSingleAppAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getSinglePublisherAppReducer = getPublisherSingleAppSlice.reducer